<!-- Zweck: Stellt die HTML-Struktur für dashboard widgets favourite menu buttons component im Frontend bereit. -->
<dashboard-widget>
  <div icon>
    <svg-icon>favorit-voll</svg-icon>
  </div>
  <div header1 matTooltip="Schnellzugriff">
    Schnellzugriff
  </div>
  <div header3>
    <button mat-icon-button (click)="reset()" matTooltip="Auf Standard zurücksetzen">
      <svg-icon>zuruecksetzen</svg-icon>
    </button>
  </div>
  <div content>
    <div class="menuboxouter tut_shopmenu_views">
      <div class="menubox">
        @for (cfg of buttons|async; track cfg) {
          <div class="menuboxEntry">
            <menu-button [name]="cfg.id" [config]="cfg" [small]="true"></menu-button>
          </div>
        }
      </div>
    </div>
  </div>
</dashboard-widget>
